import React from 'react';
import { CheckIcon } from 'lucide-react';
import { guideFeatures } from '../data/content';
export function GuideOverview() {
  return <section className="bg-paper" data-id="element-102" data-mp="2li1ixq54ls4g">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-103" data-mp="2lg766z40d6bg">
        <div className="grid items-center gap-12 lg:grid-cols-[0.95fr_1.05fr] lg:gap-20" data-id="element-104" data-mp="27iipm3gz4lc7">
          <div className="relative" data-id="element-105" data-mp="2bistnal7h1of">
            <div className="pointer-events-none absolute inset-x-6 bottom-0 top-10 rounded-[24px] bg-sage-tint" aria-hidden="true" data-id="element-106" data-mp="1xsz6cwpcmpgt" />
            <img src="https://cdn.magicpatterns.com/uploads/1U536K5jSmmTxEQJ4pCPvK/mock_up_armonia_interior.webp" alt="Ejemplar de la guía Armonía Interior sobre una mesa de madera" className="relative mx-auto w-full max-w-[380px] rounded-[16px] shadow-lift sm:max-w-[460px] lg:max-w-none" loading="lazy" width={1024} height={1024} data-id="element-107" data-mp="22jz4246albkd" />
          </div>

          <div data-id="element-108" data-mp="1ewh43lcvj76b">
            <p className="eyebrow flex items-center gap-2.5 text-[10px] text-clay sm:text-[11px]" data-id="element-109" data-mp="1jt7scvyu192t">
              <span className="h-px w-6 bg-clay/50" aria-hidden="true" data-id="element-110" data-mp="3hq0dwqj62t3o" />
              Qué vas a encontrar
            </p>

            <h2 className="mt-4 text-[31px] font-semibold leading-[1.1] tracking-[-0.015em] text-ink sm:text-[42px] sm:leading-[1.07] lg:text-[48px]" data-id="element-111" data-mp="3dp6nnqi9527m">
              Guía completa de Feng Shui para crear un hogar{' '}
              <span className="text-clay" data-id="element-112" data-mp="3mqely8krq31p">en armonía con la vida que querés</span>
            </h2>

            <p className="mt-6 text-[15.5px] leading-[1.8] text-ink-soft sm:text-[17px]" data-id="element-113" data-mp="2z0ah5xvufx94">
              Un recorrido práctico para aprender Feng Shui desde cero, analizar tu propio hogar y
              comenzar a realizar cambios conscientes sin necesitar reformas, grandes gastos ni
              conocimientos previos.
            </p>

            <ul className="mt-8 grid gap-x-8 gap-y-3.5 sm:grid-cols-2" data-id="element-114" data-mp="33wsjys7m5lit">
              {guideFeatures.map(feature => <li key={feature} className="flex items-center gap-2.5 text-[14.5px] font-medium text-ink sm:text-[15px]" data-id="element-115" data-mp="2g6ogqlyc7nsc">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage-tint" aria-hidden="true" data-id="element-116" data-mp="f7bgeanmiajl">
                    <CheckIcon className="h-3.5 w-3.5 text-sage-deep" strokeWidth={2.5} data-id="element-117" data-mp="k4lcua9fjmgx" />
                  </span>
                  {feature}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}